module.exports = __webpack_public_path__ + "assets/img/29_198_big.42172b95.jpg";